import { render } from "./AdminGraphite.vue?vue&type=template&id=2dacd5ac&scoped=true"
import script from "./AdminGraphite.vue?vue&type=script&lang=js"
export * from "./AdminGraphite.vue?vue&type=script&lang=js"

import "./AdminGraphite.vue?vue&type=style&index=0&id=2dacd5ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dacd5ac"]])

export default __exports__